"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { MarketingHomeContent, MarketingShell } from "@/components/marketing";
import { useSession } from "@/lib/session";
import { getLastWorkspaceId, resolvePostLoginPath } from "@/lib/last-workspace";

export default function HomePage() {
  const { user, loading } = useSession();
  const router = useRouter();

  useEffect(() => {
    if (loading) return;
    if (user) {
      router.replace(resolvePostLoginPath(user.workspaces, getLastWorkspaceId()));
    }
  }, [user, loading, router]);

  if (loading) {
    return (
      <div className="flex h-dvh items-center justify-center bg-[#F6F3EC]">
        <p className="text-sm font-medium text-[#5F675B]">Loading…</p>
      </div>
    );
  }

  if (user) {
    return (
      <div className="flex h-dvh items-center justify-center bg-[#F6F3EC]">
        <p className="text-sm font-medium text-[#5F675B]">Redirecting…</p>
      </div>
    );
  }

  return (
    <MarketingShell>
      <MarketingHomeContent />
    </MarketingShell>
  );
}
